import { removeItem } from '../storage';

export const handleUnauthorized = () => {
  const localStorageIsUnauthorized = localStorage.getItem('isUnauthorized');
  const isUnathorizedValitation =
    localStorageIsUnauthorized && JSON.parse(localStorageIsUnauthorized);
  if (!isUnathorizedValitation) {
    return;
  }

  removeItem('user');
  removeItem('lqaUser');
  removeItem('originalUser');
  window.location.href = '/login';
};
